import { createVuetify } from 'vuetify';
import { useLocalStorage } from '@vueuse/core';

import KitwareMark from '@/src/components/icons/KitwareLogoIcon.vue';
import {
  DefaultTheme,
  DarkTheme,
  LightTheme,
  ThemeStorageKey,
} from '@/src/constants';

const vuetify = createVuetify({
  icons: {
    values: {
      kitwareMark: {
        component: KitwareMark,
      },
    },
  },
  theme: {
    defaultTheme: DefaultTheme,
    themes: {
      [DarkTheme]: {
        dark: true,
        colors: {
          primary: '#1d9e75',
          'primary-darken-1': '#0f6e56',
          surface: '#12181d',
          background: '#0d1216',
          'selection-bg-color': '#01579b',
          'selection-border-color': '#01579b',
        },
      },

      // 허브(ProjectsHub) 라이트 웜그레이 팔레트와 통일
      [LightTheme]: {
        dark: false,
        colors: {
          primary: '#c0182b',
          'primary-darken-1': '#9c1423',
          surface: '#ffffff',
          background: '#f5f4f2',
          'on-surface': '#171717',
          'on-background': '#171717',
          'on-surface-variant': '#e7e5e4',
          'selection-bg-color': '#fdeaec',
          'selection-border-color': '#c0182b',
          success: '#15803d',
        },
      },
    },
  },
  display: {
    mobileBreakpoint: 'lg',
    thresholds: {
      lg: 1024,
    },
  },
});

const theme = useLocalStorage(ThemeStorageKey, DefaultTheme);
if (theme.value !== DarkTheme && theme.value !== LightTheme) {
  theme.value = DefaultTheme;
}
vuetify.theme.global.name.value = theme.value;

export default vuetify;
